import { useAppSelector } from "redux/hooks";
import InputRedux from "components/molecules/InputRedux";

export default function FlightNumber(props: any) {
  // const form = "AdditionalInfoForm";
  const airport = useAppSelector(
    (state) =>
      state.form?.["SearchTripForm"]?.values?.pickup?.details?.airport ||
      state.form?.["SearchHourlyForm"]?.values?.pickup?.details?.airport
  );

  // return airport ? <InputRedux {...props} /> : null;
  return <InputRedux {...props} />;
}
